import React from 'react';

interface TransporterIdCardProps {
  name: string;
  image?:string;
  transporterId: string;
}

export const TransporterIdCard: React.FC<TransporterIdCardProps> = ({
  name,
  image,
  transporterId,
}) => {
  return (
    <div className="flex items-center justify-between rounded-[12px] border border-gray-200 bg-white px-6 py-4">
      {/* Left */}
      <div className="flex items-center gap-4">
        <div className="flex items-center justify-center h-16 rounded-lg  overflow-hidden">
          {image ? (
            <img src={image} alt={name} className="max-h-full max-w-full object-contain" />
          ) : (
            <span className="text-xs font-semibold text-gray-400">NO LOGO</span>
          )}
        </div>
        {/* <span className="font-medium text-gray-900">{name}</span> */}
      </div>

      {/* Right */}
      <span className="font-bold text-text text-base tracking-wide">
        {transporterId}
      </span>
    </div>
  );
};
